import { create } from "zustand";

type ToastKind = "info" | "success" | "error";

interface UIState {
  toast: { msg: string; kind: ToastKind } | null;
  showToast: (msg: string, kind?: ToastKind) => void;
  clearToast: () => void;
}

export const useUIStore = create<UIState>((set) => ({
  toast: null,
  showToast: (msg, kind = "info") => {
    set({ toast: { msg, kind } });
    setTimeout(() => set({ toast: null }), 3000);
  },
  clearToast: () => set({ toast: null }),
}));
